export default {
  home: "home",
  pickup: "pickup",
};
